import React from 'react';

import cn from 'classnames';

import bem from 'client/services/bem';

import cssModule from './popover-content.module.scss';

const b = bem('popover-content', {cssModule});

export type PopoverContentProps = React.HTMLAttributes<HTMLDivElement> & {
  variant?: 'dark' | 'light' | 'tooltip' | 'editor';
};

const PopoverContent = React.forwardRef<HTMLDivElement, PopoverContentProps>(
  ({children, variant = 'light', className, ...props}, ref) => {
    return (
      <div className={cn(b([variant]), className)} ref={ref} {...props}>
        {children}
      </div>
    );
  },
);

export default PopoverContent;
